/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

// MAIN COLORS - VUESAX THEME COLORS
import { config } from "/app.config"
import Vue from "vue"
import Vuesax from "vuesax"

export const colors = {
  base: "#626262",
  primary: config.colors.primary,
  success: config.colors.success,
  danger: config.colors.danger,
  warning: config.colors.warning,
  dark: "#1E1E1E",
}

// CONFIGS
const themeConfig = {
  footerType: "static", // options[String]  : static(default) / sticky / hidden
  hideScrollToTop: true, // options[Boolean] : true, false(default)
  navbarColor: "#fff", // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType: "sticky", // options[String]  : floating(default) / static / sticky / hidden
  routerTransition: "fade", // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
  rtl: false, // options[Boolean] : true, false(default)
  sidebarCollapsed: false, // options[Boolean] : true, false(default)
  theme: "light", // options[String]  : "light"(default), "dark", "semi-dark"
}

Vue.use(Vuesax, { theme: { colors }, rtl: themeConfig.rtl })

export default themeConfig
